<div class="references-panel" *ngIf="data" #panelElRef>
  <div class="references-panel__content">

    <h2 class="references-panel__title" *ngIf="data.title" #titleEl>{{ data.title.value }}</h2>

    <div class="references-panel__wrapper"
      [ngClass]="{'references-panel__wrapper-single': data.items.value.length === 1}" #itemsElRef>
      <div *ngFor="let item of data.items.value; let i = index;">
        <img src="{{ item.image.value.src }}"
         alt="{{ item.image.value.alt }}"
         loading="lazy"
         draggable="false"
         [ngStyle]="{aspectRatio: item.image?.value?.width / item.image?.value?.height}" />
      </div>
    </div>

  </div>
</div>
